<script>
const SHARE_HOLDER_MAX_NUMBER = 6;
export default {
  props: ['value'],
  data() {
    return {
      shareHolders: [{}],
      inputNumberOfShareHolders: 1,
      confidential: false,
      shareHoldersOptions: [
        {
          value: 1,
          label: 'One'
        },
        {
          value: 2,
          label: 'Two'
        },
        {
          value: 3,
          label: 'Three'
        },
        {
          value: 4,
          label: 'Four'
        },
        {
          value: 5,
          label: 'Five'
        },
        {
          value: 6,
          label: 'More than five'
        },
      ]
    }
  },
  mounted() {
    if (this.value ) {
      this.shareHolders = this.value.shareholders? this.value.shareholders.concat([]): [];
      this.confidential = this.value.confidential;
    }
  },
  methods: {
    remove(index) {
      this.shareHolders.splice(index, 1);
      this.inputNumberOfShareHolders = this.shareHolders.length;
    },
    changeShareHolderNumber(_number) {

      // we want to keep the current on remove / add
      let newShareHolders = [];
      let shareHoldersNumber = _number;
      for (let i = 0; i < shareHoldersNumber && i < SHARE_HOLDER_MAX_NUMBER; i++) {
        newShareHolders.push({});
      }

      // copy current
      for (let i = 0; i < newShareHolders.length
      && i < this.shareHolders.length
      && i < shareHoldersNumber && i < SHARE_HOLDER_MAX_NUMBER; i++) {
        if (this.shareHolders[i]) {
          newShareHolders[i] = this.shareHolders[i];
        }
      }
      this.shareHolders = newShareHolders;
    },
  },
  computed: {
    total() {
      let sum = 0;
      for (let item of this.shareHolders) {
        if (item.percentage) {
          sum += parseFloat(item.percentage);
        }
      }
      return sum;
    }
  },
  watch: {
    shareHolders(newVal, oldVal) {
       this.$emit('input', {
         share_holders: newVal,
         confidential: this.confidential
       });
    },
    confidential(newVal, oldVal) {
      this.$emit('input', {
         share_holders: this.shareHolders,
         confidential: newVal
       });
    },

  }
};
</script>

<template>
  <div class="fund-use-input">
    <div class="title-md">
      Shareholders
    </div>


    <div class="columns">
      <div class="column">
        <div class="control">
          <div class="field radio-field">
            <label class="label">
              Total Number of shareholders
            </label>
            <div class="sep-16"></div>
            <div class="control radio-group" vrules="required">
              <label class="radio" v-for="(answer, index) in shareHoldersOptions">
                <input :value="answer.value"
                       type="radio"
                       name="shareholder-numbers"
                       @click="changeShareHolderNumber(answer.value)"
                       v-model="inputNumberOfShareHolders"/>
                {{ answer.label }}
              </label>
              <div class="help is-danger vrule" rule="required">
                This field is required.
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="field">
      <input type="hidden" vrules="required" name="fund-user-validation" :value="!confidential && total !== 100? '': 1">
      <div class="vrule " style="color: red" rule="required" v-if="total !== 100 && !confidential">
        Shareholders percentages sum must be 100%.
      </div>
    </div>

    <div class="sep-8"></div>
    <h3 class="light">
      Please add shareholder(s) details
    </h3>
    <div class="sep-8"></div>
    <div class="control">
      <div class="field radio-field">
        <label class="label" style="font-size: 14px;">
          <input type="checkbox" name="confidential" v-model="confidential" :value="true"> Confidential
        </label>
      </div>
    </div>
    <div class="sep-16"></div>
    <div class="columns" v-for="(item, index) in shareHolders" v-if="!confidential">

      <fragment v-if="index<5">
        <div class="column is-4">
          <div class="control">
            <div class="field">
              <label class="label">
                First Name
              </label>
              <input placeholder="First Name" style="width: auto" vrules="required" type="text" class="input"
                     v-model="item.first_name">
              <div class="vrule help is-danger" rule="required">
                This field is required.
              </div>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="control">
            <div class="field">
              <label class="label">
                Last Name
              </label>
              <input placeholder="Last Name" style="width: auto" vrules="required" type="text" class="input"
                     v-model="item.last_name">
              <div class="vrule help is-danger" rule="required">
                This field is required.
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">
              Percent.
            </label>
            <div class="icon-control inverse">
              <input :id="'fund-'+index" type="number" vrules="required" min="0" placeholder="%"
                     class="input" v-model.number="item.percentage"/>
              <div class="icon-input">
                %
              </div>
            </div>
            <div class="vrule help is-danger" rule="required">
              Required.
            </div>
          </div>

        </div>
        <div class="column">
          <div class="clear-share-holder" v-if="index>0" @click="remove(index)">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                 style="enable-background:new 0 0 24 24;" xml:space="preserve">

                        <g id="Close">
                            <polygon id="Fill-2" class="st0" points="18,7.4 16.6,6 12,10.6 7.4,6 6,7.4 10.6,12 6,16.6 7.4,18 12,13.4 16.6,18 18,16.6
                                13.4,12 	"/>
                        </g>
                    </svg>

          </div>
        </div>
      </fragment>
      <fragment v-if="index === 5">

        <div class="column is-4">
          <div class="field">
            <label class="label">
              Others Percent.
            </label>
            <div class="icon-control inverse">
              <input :id="'fund-'+index" type="number" vrules="required" min="0" placeholder="%"
                     class="input" v-model.number="item.percentage"/>
              <div class="icon-input">
                %
              </div>
            </div>
            <div class="vrule help is-danger" rule="required">
              Required.
            </div>
          </div>

        </div>
        <div class="column">
          <div class="clear-share-holder" v-if="index>0" @click="remove(index)">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                 style="enable-background:new 0 0 24 24;" xml:space="preserve">

                        <g id="Close">
                            <polygon id="Fill-2" class="st0" points="18,7.4 16.6,6 12,10.6 7.4,6 6,7.4 10.6,12 6,16.6 7.4,18 12,13.4 16.6,18 18,16.6
                                13.4,12 	"/>
                        </g>
                    </svg>

          </div>
        </div>
      </fragment>

    </div>
    <div class="sep-10"></div>
    <!--    <div class="row">-->
    <!--      <div class="col-12">-->
    <!--        <div v-if="shareHolders.length < 10" class="add-shareholder" @click="addShareHolder()">-->
    <!--          + Add Shareholder-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->

    <div v-if="shareHolders.length > 6" class="help is-danger">
      The maximum number of shareholders is 6.
      <div class="sep-10"></div>
    </div>

  </div>
</template>

<style lang="scss" scoped>
@import "../../../style/vars";

.fund-use-input {
  padding: 0px;
}

.percentage-label {
  margin-top: 7px;
}

.add-shareholder {
  font-weight: bold;
  cursor: pointer;
  color: $primary;
  margin-bottom: 15px;
}

.input-group {
  .input-group-text {
    border-left: none;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}

.clear-share-holder {
  line-height: 60px;
  cursor: pointer;
  position: relative;
  top: 32px;

  svg {
    width: 24px;
    height: 24px;
    fill: #A7ACB2;
  }
}

.icon-control input {
  width: 60px;
}
</style>
